export function someFromIndex<T>(
  array: T[],
  startIndex: number,
  predicate: (item: T, index: number) => boolean
): boolean {
  for (let i = startIndex; i < array.length; i++) {
    if (predicate(array[i], i)) {
      return true;
    }
  }
  return false;
}

export function countAndCheckFollowingItems<T extends object, K extends keyof T, P extends keyof T>(
  array: T[],
  startIndex: number,
  propertyName: K,
  expectedValue: T[K],
  flagProperty: P
): { count: number; hasFlag: boolean } {
  let count = 0;
  let hasFlag = false;

  for (let i = startIndex + 1; i < array.length; i++) {
    const item = array[i];

    // Si la propriété principale ne correspond pas → on arrête
    if (!(propertyName in item) || item[propertyName] !== expectedValue) {
      break;
    }

    // Incrémenter le compteur
    count++;

    // Vérifier si la propriété "flag" est présente et vraie
    if (flagProperty in item && typeof item[flagProperty] === 'number') {
      hasFlag = true;
    }
  }

  return { count, hasFlag };
}
